import clsx from 'clsx'
import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'
import { Anchor } from 'components/Anchor'

import type { ITopic } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  ITopic & { className?: string }
>(
  (
    {
      title,
      subtitle,
      moduleAmount,
      thumbnailUrl,
      className,
      id,
      trackerWidgetData,
    },
    ref
  ) => {
    const url = getNonGeneralWidgetUrl({ type: NON_GENERAL_WIDGET.Topic, id })
    return (
      <Anchor href={url}>
        <a href={url} className="mb-2 last:mb-0 block">
          <div
            className={clsx(
              'rounded border border-subdued p-3 justify-between',
              'flex gap-4',
              'cursor-pointer',
              className
            )}
            ref={ref}
            onClick={() =>
              trackWidgetClick({
                ...trackerWidgetData,
                widgetValue: {
                  ...trackerWidgetData.widgetValue,
                  url,
                },
              })
            }
          >
            <div>
              <Text className="mb-1 line-clamp-2" variant="heading-sm">
                {title}
              </Text>
              <Text
                variant="body-sm"
                className="mb-0 mt-0.5 line-clamp-2"
                color="subdued"
              >
                {subtitle}
              </Text>
              <div className="flex gap-2 mt-3">
                <Icon
                  as="i"
                  color="default"
                  style={{ fontSize: '16px' }}
                  fontSize="sm"
                >
                  library_books
                </Icon>
                <Text variant="helper-bold" color="subdued" className="mb-0">
                  {moduleAmount} modul
                </Text>
              </div>
            </div>
            <div className="relative flex-grow-0 flex-shrink-0 w-16 h-16 rounded overflow-hidden">
              {!!thumbnailUrl && (
                <img
                  className="object-cover object-center w-16 h-16"
                  alt="topic thumbnail"
                  src={thumbnailUrl}
                />
              )}
              {!thumbnailUrl && (
                <div className="grid place-items-center w-16 h-16 bg-gray-30">
                  <Icon>article</Icon>
                </div>
              )}
            </div>
          </div>
        </a>
      </Anchor>
    )
  }
)
BaseWidget.displayName = 'Topic'

export default BaseWidget
